






































import { Component, Vue } from "vue-property-decorator";
@Component({
    props: {
        post: {
            type: Object,
            default: () => ({
                image: String,
                date: String,
                name: String,
                url: String,
                medio: String,
            }),
        },
        medios: {
            type: Array,
            default: () => []
        }
    },
})
export default class NewPressCard extends Vue {
    post!: {
        image: string;
        date: string;
        name: string;
        url: string;
        medio: string;
    };

    get medio() {
        const medioResource = this.$props.medios.find(({ slug }: { slug: string }) => slug === this.post.medio);
        if (medioResource) return medioResource.medio;
        return "-";
    }

    get dateFormated() {
        if (!this.post.date) return " - ";
        const [day, month, year] = this.post.date.split('-');
        const date = new Date(Number(year), Number(month) - 1, Number(day));
        const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'long', year: 'numeric', timeZone: 'America/Santiago' };
        return date.toLocaleDateString('es-CL', options).replace(/^\d{2}/, (day) => day.padStart(2, '0'));
    }
}
